import React, { useState } from "react";
import styled from "@mui/material/styles/styled";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
const Accordion = styled((props) => (React.createElement(MuiAccordion, Object.assign({ disableGutters: true, elevation: 0, square: true }, props))))(({ theme }) => ({
    border: "1px solid rgba(0, 0, 0, .125)",
    backgroundColor: "#ffffff",
    boxShadow: "none",
    padding: "0px",
    "&:not(:last-child)": {
        borderBottom: 0,
    },
    "&:before": {
        display: "none",
    },
    "&$expanded": {
        margin: "auto",
    },
}));
const AccordionSummary = styled((props) => (React.createElement(MuiAccordionSummary, Object.assign({ expandIcon: React.createElement(ExpandMoreIcon, { sx: { fontSize: "1.5rem" } }) }, props))))(({ theme }) => ({
    backgroundColor: "#ffffff",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 49,
    position: "fixed",
    zIndex: 100,
    width: "100%",
    paddingLeft: "24px",
    paddingRight: "5px",
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
        minHeight: 12,
        transform: "rotate(180deg)",
    },
    "& .MuiAccordionSummary-content": {
        marginLeft: theme.spacing(1),
    },
}));
const AccordionSummary2 = styled((props) => (React.createElement(MuiAccordionSummary, Object.assign({ expandIcon: React.createElement(ExpandMoreIcon, { sx: { fontSize: "1.5rem" } }) }, props))))(({ theme }) => ({
    backgroundColor: "#ffffff",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    borderTop: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: 56,
    minHeight: 49,
    width: "100%",
    zIndex: 1031,
    position: "fixed",
    paddingLeft: "24px",
    paddingRight: "5px",
    bottom: "0",
    "&.Mui-expanded": {
        paddingLeft: "24px",
        paddingRight: "5px",
        top: 105,
        marginBottom: "100vh",
    },
    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
        transform: "rotate(180deg)",
    },
    "& .MuiAccordionSummary-content": {
        marginLeft: theme.spacing(1),
    },
}));
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: 0,
    marginTop: 48,
    height: "100vh",
}));
const AccordionDetails2 = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: 0,
    marginTop: 75,
    height: "50vh",
}));
export const AccordianTransaction = (props) => {
    const [panel, setPanel] = useState("panel2");
    const changePannel = (currentPlannel) => {
        if (currentPlannel === "panel1") {
            setPanel("panel2");
        }
        else {
            setPanel("panel1");
        }
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Accordion, { expanded: panel === "panel1", onChange: () => changePannel(panel) },
            React.createElement(AccordionSummary, { "aria-controls": "panel1d-content", id: "panel1d-header", style: { backgroundColor: "#fff" } },
                React.createElement("span", { className: "labelRECENTTRANSACTIONS" }, props.titleOne)),
            React.createElement(AccordionDetails, null,
                React.createElement("div", null, React.createElement(props.ComponentOne, null)))),
        React.createElement(Accordion, { expanded: panel === "panel2", onChange: () => changePannel(panel) },
            React.createElement(AccordionSummary2, { "aria-controls": "panel2d-content", id: "panel2d-header", style: { backgroundColor: "#fff" } },
                React.createElement("span", { className: "labelRECENTTRANSACTIONS" }, props.titleTwo)),
            React.createElement(AccordionDetails2, null,
                React.createElement("div", { style: { marginTop: 100 } }, React.createElement(props.ComponentTwo, null))))));
};
